import React from 'react';
import './CutomModal.css'; // Custom CSS for the modal
import  Async from "react-select";

const CustomModal = ({ isOpen, onClose, onSave, srValue, srValueObj,getSampleRequestList,handleSRValueSelect,sampleRequestList, handleInputChange }) => {

  // getSampleRequestList = (inputValue) => {
  //   SampleServices.getSampleReqNo(inputValue)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         this.setState({
  //           sampleRequestList: response.text.data, // assuming format: [{ label, value }]
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Failed to fetch sample request numbers", err);
  //     });
  // };


  if (!isOpen) return null; // If modal is not open, don't render

  return (
    <div className="modal-overlay">
  <div className="modal-content">
    {/* Close button in the top right corner */}
    <button
    className='close-button'
      style={{
        position: "absolute",
        top: "4px",
        right: "10px",
        background: "none",
        border: "none",
        fontSize: "26px",
        cursor: "pointer",
      }}
      onClick={onClose} // Close the modal when clicked
    >
      {/* <i className="fa fa-close"  style={{
      fontSize: "28px", // Adjust this for larger size
      fontWeight: 400, // Try 400 or 300 for a lighter look
      fontFamily: "FontAwesome", // Ensuring it's using FontAwesome styles
    }}></i>  */} x
    </button>

    <h3>Duplicate File</h3>

    <span style={{marginBottom:"10px", fontWeight:"600"}}>Sample Request Id</span>
    {/* <input
      type="text"
      name="srvalueDup"
      value={srValue}
      onChange={handleInputChange}
      style={{borderRadius:"4px",
        border:"1px solid"}}
      placeholder="Enter Sample Request ID"
      maxLength={75}
    /> */}
    <div className='customCompAsync'>
    <Async
  name="srvalueDup"
  value={srValueObj || null}
  onInputChange={getSampleRequestList}
  onMenuOpen={() => getSampleRequestList("")}
  onChange={handleSRValueSelect}
  placeholder="Find Sample Request No."
  options={sampleRequestList}
/>
</div>

    <div style={{ marginTop: "10px" }}>
      <button
        style={{
          padding: "4px 14px",
          backgroundColor: "#009688",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
        onClick={onSave} // Call the save function
      >
        Save
      </button>
      <button
        style={{
          backgroundColor: "white",
          color: "#009688",
          border: "1.5px solid #009688",
          borderRadius: "5px",
          padding: "4px 14px",
          cursor: "pointer",
        }}
        onClick={onClose} // Close modal on cancel
      >
        Cancel
      </button>
    </div>
  </div>
</div>
  );
};

export default CustomModal;



// WEBPACK FOOTER //
// ./src/components/SampleRequest/PatternModule/customModal/CustomModal.js